<template>
  <v-container class="pa-0">
    <v-form ref="user-form">
      <v-app-bar
        color="transparent"
        class="elevation-0 pa-0 page-header-toolbar"
      >
        <page-header-title
          :title="$t('persons.qrcode_title')"
        ></page-header-title>
        <v-spacer></v-spacer>
        <action-button type="back" @click="$router.go(-1)" :icon_only="true" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-2">
            <v-layout row wrap>
              <v-flex xs12>
                <p class="font-weight-bold text-center text-uppercase mb-1">
                  {{ person.first_name + " " + person.last_name }}
                </p>
              </v-flex>
              <v-flex xs12 class="pr-4">
                <v-img
                  v-if="person.qrcode_url"
                  :src="person.qrcode_url ? person.qrcode_url : no_image"
                  aspect-ratio="1"
                ></v-img>

                <v-btn
                  v-if="!person.qrcode_url"
                  @click="generateQRCode()"
                  class="d-block darken-2"
                  width="100%"
                  color="success"
                  >{{ $t("persons.qr_generate") }}</v-btn
                >
              </v-flex>
              <v-flex xs12>
                <p class="font-weight-bold text-center text-uppercase mb-1">
                  {{
                    $t("users.unique_id") +
                      ": " +
                      (person.unique_id ? person.unique_id : "")
                  }}
                </p>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <p class="caption d-block font-weight-light text-center mt-5">
          {{ $t("persons.last_updated_sync") }}: {{ computedLastDateSynced }}
        </p>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import { ActionButton } from "@brakomp/ui"

export default {
  components: { ActionButton },
  name: "UserQRCode",

  props: ["id"],

  data() {
    return {
      user: {},
      person: {
        first_name: "",
        last_name: "",
      },
    }
  },

  mounted() {
    this.loadUser()
  },

  watch: {
    current: {
      handler() {
        if (_.has(this.current, "id")) {
          this.loadUser()
        }
      },
    },
  },

  computed: {
    current() {
      let user = this.$store.getters["auth/user"]

      if (!user) {
        user = this.$store.getters["auth/localUser"]
      }

      return user
    },
    computedLastDateSynced: {
      get() {
        return (
          this.$dateFormatGetter(
            this.person.last_sync_date,
            this.MYSQL_DATETIME_FORMAT,
          ) +
          " " +
          this.$timeFormatGetter(
            this.person.last_sync_date,
            this.MYSQL_DATETIME_FORMAT,
          )
        )
      },
      set(val) {
        this.$set(this.person, "last_sync_date", this.$dateFormatSetter(val))
      },
    },
  },

  methods: {
    loadUser() {
      let id = null

      if (this.id) id = this.id
      if (!id) id = this.current.id

      if (id) {
        axios
          .get(this.API_URL + "user/" + id)
          .then(res => {
            this.user = res.data.data
            this.person = res.data.data.person

            this.setPageTitle()

            this.isAdmin =
              this.$hasRole("system-developer") || this.$hasRole("superuser")
          })
          .catch(err => console.log(err))
      }
    },

    generateQRCode() {
      axios
        .post(this.API_URL + "user/generateQRCode", {
          id: this.id,
        })
        .then(res => {
          this.user = res.data.data
          this.person = res.data.data.person

          this.setPageTitle()

          this.isAdmin =
            this.$hasRole("system-developer") || this.$hasRole("superuser")
        })
        .catch(err => console.log(err))
    },
  },
}
</script>

<style scoped>
.fab-update-image {
  bottom: 5px !important;
  right: 0px !important;
}
</style>
